/* eslint class-methods-use-this: 0 */
import { IGridHelper } from '@components-clean/core/api-grid/helpers/interfaces';
import { CustomCells } from '@components-clean/core/grid/custom-cell';
import { ChipProps, RAGPillColours } from '@components-clean/core/grid/custom-cell/chip-constants';
import { ColumnDefinition } from '@interfaces/central-monitoring';

const gridColumns = {
    Dataset: 'dataset_date',
    Panel: 'plot_title',
    QTL: 'qtl',
    TimePeriod: 'bin_label_date',
    YAxis: 'y_axis',
    YAxisTitle: 'y_title',
    YValue: 'y_value',
    Numerator: 'numerator_cols',
    NumeratorField: 'numerator_field',
    NumeratorValue: 'numerator_events',
    Denominator: 'denominator_cols',
    DenominatorField: 'denominator_field',
    DenominatorValue: 'denominator_value',
    OutOfTolerance: 'out_of_tolerance',
    OutOfToleranceType: 'out_of_tolerance_desc',
    OutOfToleranceValue: 'out_of_tolerance_value',
    PlotCalculations: 'plot_calculation',
    NoOfSubjects: 'no_of_subjects',
    ExpectedValue: 'expected_volume',
};

const ragChips: ChipProps[] = [
    {
        text: 'Upper Red',
        value: 'Upper Red',
        backgroundColor: RAGPillColours.ragRed,
        borderColor: RAGPillColours.ragRedBorder,
    },
    {
        text: 'Upper Amber',
        value: 'Upper Amber',
        backgroundColor: RAGPillColours.ragAmber,
        borderColor: RAGPillColours.ragAmberBorder,
    },
    {
        text: 'Lower Amber',
        value: 'Lower Amber',
        backgroundColor: RAGPillColours.ragAmber,
        borderColor: RAGPillColours.ragAmberBorder,
    },
    {
        text: 'Lower Red',
        value: 'Lower Red',
        backgroundColor: RAGPillColours.ragRed,
        borderColor: RAGPillColours.ragRedBorder,
    },
];

export class ControlsHubOoTGridHelper implements IGridHelper {
    private _customCells: CustomCells;

    constructor(private customCells: CustomCells) {
        this._customCells = customCells;
    }

    getDisplayFields() {
        return true;
    }

    getActiveField() {
        return undefined;
    }

    getDisplayTooltipFields(columnType: ColumnDefinition) {
        switch (columnType.dataField) {
            case gridColumns.Panel:
            case gridColumns.YAxisTitle:
            case gridColumns.NumeratorField:
            case gridColumns.DenominatorField:
                return true;
            default:
                return false;
        }
    }

    isRagColumn() {
        return false;
    }

    disableLock() {
        return false;
    }

    multiValueFilter() {
        return false;
    }

    getColumnWidth() {
        return undefined;
    }

    getCustomCell(columnType: ColumnDefinition) {
        switch (columnType.dataField) {
            case gridColumns.OutOfToleranceType:
                return this._customCells.ChipCell(ragChips, { width: 120 });
            default:
                return undefined;
        }
    }

    disableAdvancedFilter() {
        return false;
    }
}
